module.exports = __webpack_public_path__ + "img/menu-logo.d7af8e1f.svg";